import React from 'react'
import { ImageMarginEnum, StyledCarrouselMedia, StyledParagraph } from './SlideMedia.styled'
import NormalizeMedia from '../../../utils/NormalizeMedia'

const SlideMedia = (medias) => {
  if (!medias) return null

  const filteredMedias = medias.filter(
    (media) =>
      media.youtubeUrl || media.contentfulAsset || media.cloudinaryAsset || media.iframeUrl
  )

  return filteredMedias.map((media, index) => {
    if(media.sys?.contentType?.sys.id === "contentMedia") {
     return  <StyledCarrouselMedia key={index}>
        {NormalizeMedia(media)}
        {media.caption && (
          <StyledParagraph
            variant={!media.caption && ImageMarginEnum.withoutText}
          >
            {media.caption.caption}
          </StyledParagraph>
        )}
      </StyledCarrouselMedia>
    }
    if(media.sys?.contentType?.sys.id === "contentIframe") {
      return (
        <StyledCarrouselMedia key={index}>
          <iframe src={`${media.iframeUrl}`} allow="microphone; accelerometer; gyroscope; vr; fullscreen; xr-spatial-tracking"/>
        </StyledCarrouselMedia>
      )
    } else {
      return  <StyledCarrouselMedia key={index}>
        {NormalizeMedia(media)}
        {media.caption && (
          <StyledParagraph
            variant={!media.caption && ImageMarginEnum.withoutText}
          >
            {media.caption.caption}
          </StyledParagraph>
        )}
      </StyledCarrouselMedia>
    }
  })
}

export default SlideMedia
